// Apartament 2 camere - Ploiesti, Str. Infratirii
// Route: /ploiesti

import img01 from '../media/ploiesti/01-IMG-20230621-WA0006.jpg';
import img02 from '../media/ploiesti/02-IMG-20230621-WA0003.jpg';
import img03 from '../media/ploiesti/03-IMG-20230621-WA0018.jpg';
import img04 from '../media/ploiesti/04-IMG-20230621-WA0014.jpg';
import img05 from '../media/ploiesti/05-IMG-20230621-WA0015.jpg';
import img06 from '../media/ploiesti/06-IMG-20230621-WA0012.jpg';
import img07 from '../media/ploiesti/07-IMG-20230621-WA0004.jpg';
import img08 from '../media/ploiesti/08-IMG-20230621-WA0008.jpg';
import img09 from '../media/ploiesti/09-IMG-20211026-WA0020.jpg';
import img10 from '../media/ploiesti/10-IMG-20230621-WA0024.jpg';
import img11 from '../media/ploiesti/11-IMG-20230621-WA0028.jpg';
import img12 from '../media/ploiesti/12-IMG-20211026-WA0012.jpg';
import img13 from '../media/ploiesti/13-IMG-20230621-WA0023.jpg';
import img14 from '../media/ploiesti/14-IMG-20230621-WA0022.jpg';
import img15 from '../media/ploiesti/15-IMG-20230621-WA0016.jpg';
import img16 from '../media/ploiesti/16-IMG-20211026-WA0004.jpg';
import img17 from '../media/ploiesti/17-IMG-20211026-WA0001.jpg';
import img18 from '../media/ploiesti/18-IMG-20211026-WA0029.jpg';
import img19 from '../media/ploiesti/19-IMG-20211026-WA0002.jpg';
import img20 from '../media/ploiesti/20-IMG-20211026-WA0003.jpg';
import floorPlan from '../media/ploiesti/IMG-20211026-WA0015.jpg';

const ploiesti = {
  id: 'ploiesti',
  path: '/ploiesti',
  documentTitle: 'Apartament 2 camere de vânzare - Ploiești, Str. Înfrățirii',
  metaDescription:
    'Apartament 2 camere de vânzare în Ploiești, Str. Înfrățirii, Nr. 5A, Bl. 67 bis - 50.000 € | Direct de la proprietar, comision 0% | 0749 784 880',

  // Owner is abroad and cannot take regular calls, so contact goes to WhatsApp.
  phone: {
    display: '0749 784 880',
    href: 'https://wa.me/40749784880',
    icon: '💬',
    intro: 'Contactează-mă pentru o vizionare',
    cta: 'Scrie-mi pe WhatsApp pentru detalii!',
    ariaLabel: 'Scrie-mi pe WhatsApp la 0749 784 880',
    channel: 'whatsapp',
  },
  price: '50.000 €',
  topBarNotes: [
    { icon: '👤', text: 'Direct de la proprietar' },
    { icon: '✓', text: 'Comision 0%', highlight: true },
  ],

  badge: 'De Vânzare',
  title: 'Apartament 2 camere în Ploiești',
  subtitle: 'Str. Înfrățirii, Nr. 5A, Bl. 67 bis',

  gallery: [
    img01, img02, img03, img04, img05, img06, img07, img08, img09, img10,
    img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
  ],
  heroImage: img01,

  infoItems: [
    { icon: '🛏️', text: '2 Camere' },
    { icon: '📐', text: '51,9 mp' },
    { icon: '🏢', text: 'Etaj 10/10' },
    { icon: '📍', text: 'Ploiești' },
    { icon: '💰', text: '50.000 €' },
    { icon: '✓', text: 'Comision 0%' },
  ],

  floorPlan: {
    image: floorPlan,
    heading: 'Plan Apartament',
    description: 'Vizualizează dispunerea camerelor',
  },

  features: [
    { icon: '🏠', title: 'Tip Apartament', text: '2 camere, decomandat' },
    { icon: '📐', title: 'Suprafață Utilă', text: '48,6 mp' },
    { icon: '📏', title: 'Suprafață Totală', text: '51,9 mp (cu balcon)' },
    { icon: '🏢', title: 'Etaj', text: '10 din 10' },
    { icon: '🔥', title: 'Încălzire', text: 'Centrală proprie' },
    { icon: '❄️', title: 'Climatizare', text: 'Aer condiționat' },
    { icon: '🧱', title: 'Structură rezistență bloc', text: 'Beton, izolat termic' },
    { icon: '📅', title: 'An Construcție', text: '1978' },
    { icon: '🌳', title: 'Vecinătate', text: 'Parcul Aurora în față' },
  ],

  location: {
    summary: 'Ploiești, Str. Înfrățirii, Nr. 5A, Bl. 67 bis',
    addressLines: [
      'Str. Înfrățirii, Nr. 5A',
      'Bl. 67 bis',
      'Ploiești, Județul Prahova',
      'România',
    ],
    mapEmbedSrc:
      'https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d442.283323713493!2d25.98595984219017!3d44.93635881747327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sstr%20infratirii%20nr%205a%20bl%2067%20bis%20ploiesti!5e1!3m2!1sro!2sch!4v1768834195424!5m2!1sro!2sch',
  },

  footerText: 'Apartament de vânzare • Ploiești, Str. Înfrățirii • 50.000 €',
};

export default ploiesti;
